<template>
  <div>
    <data-table :service="RoleService"
                :entity="entity"
                :columns="columns"
                :disable-permission-checks="true"
                operations="refresh,edit,add"
                ref="table">
      <template v-slot:name="{row}">
        {{formatName(row.name)}}
      </template>
      <template v-slot:guard_name="{row}">
        <template v-if="row.guard_name === 'api_client'">
          {{$t('roles.guard_name.client')}}
        </template>
        <template v-else-if="row.guard_name === 'api_user'">
          {{$t('roles.guard_name.user')}}
        </template>
        <template v-else>
          {{row.guard_name}}
        </template>
      </template>
    </data-table>
  </div>
</template>
<script>
  import startCase from 'lodash/startCase'
  import camelCase from 'lodash/camelCase'
  import RoleService from 'src/services/RoleService';
  import {entities} from 'src/config/routeTypes';

  export default {
    name: 'role-settings',
    data() {
      return {
        RoleService,
        entity: entities.ROLE
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "name",
            label: this.$t('roles.name'),
            minWidth: "140px"
          },
          {
            prop: "guard_name",
            label: this.$t('roles.guard_name'),
            minWidth: "140px"
          }
        ]
      }
    },
    methods: {
      formatName(name) {
        return startCase(camelCase(name))
      }
    }
  }
</script>
<style>
</style>
